function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-72c1d2ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PCS01_ResponseDisplay.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PCS01_ResponseDisplay.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72c1d2ec\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PCS01_ResponseDisplay.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72c1d2ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/ulip/PCS01_ResponseDisplay.vue
// module id = 2271
// module chunks = 0